export type SignatureSettingsAttributesDto = {
    signatureLogoId: string
    signature: string
    isEnable: boolean
    logoUrl:string
}

export default class SignatureSettings{
    signatureLogoId: string
    signature: string
    isEnable: boolean
    logoUrl:string

    constructor(signatureSettings: SignatureSettingsAttributesDto) {
        this.signatureLogoId = signatureSettings?.signatureLogoId
        this.logoUrl=signatureSettings?.logoUrl
        this.signature = signatureSettings?.signature
        this.isEnable = !!signatureSettings.isEnable
    }
}


// WEBPACK FOOTER //
// ./src/state/user/SignatureSettings.ts